export const aboutInfo = {
  brandName: '快猫短视频',
  slogan: '发现精彩，记录生活',
  foundedYear: '2020',
  mission: '让每个人都能轻松发现有趣内容，让创作者实现内容变现',
  vision: '成为全球领先的短视频内容生态平台',
  story: '快猫短视频诞生于2020年，由一群热爱内容创作的年轻人发起。我们相信每个人都有独特的故事值得被看见，每个创作者都应该获得应有的回报。从最初的几十个用户到如今服务数千万用户，快猫短视频始终坚持"内容为王、创作者为本"的理念，不断优化推荐算法，打造健康的内容生态。',
  values: [
    { title: '内容至上', description: '坚持原创优质内容，为用户提供有价值的短视频体验', icon: 'ri-star-line' },
    { title: '创作者为本', description: '构建公平透明的变现体系，让创作者获得应有回报', icon: 'ri-user-heart-line' },
    { title: '技术创新', description: '持续投入AI推荐算法研发，精准匹配用户兴趣', icon: 'ri-cpu-line' },
    { title: '社区共治', description: '建立健康友善的社区氛围，守护内容安全底线', icon: 'ri-shield-check-line' },
  ],
  stats: [
    { label: '日活用户', value: '5000万+' },
    { label: '入驻创作者', value: '200万+' },
    { label: '日均视频上传', value: '100万+' },
    { label: '覆盖国家地区', value: '30+' },
  ],
  testimonials: [
    { name: '王先生', role: '搞笑类创作者', content: '在快猫短视频创作三年，从零粉丝到现在两百万粉丝，平台的分成机制很透明，让我可以全职做自己喜欢的事情。', avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20with%20a%20friendly%20confident%20smile%2C%20casual%20style%2C%20cream%20background%2C%20warm%20portrait%20lighting&width=100&height=100&seq=testimonial-01&orientation=squarish' },
    { name: '李女士', role: '美食类创作者', content: '快猫的AI推荐真的厉害，我的第一条视频就获得了十万播放，给了我巨大的信心继续创作下去，现在已经是全职美食博主了。', avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20with%20a%20warm%20smile%2C%20simple%20style%2C%20cream%20background%2C%20professional%20portrait%20lighting&width=100&height=100&seq=testimonial-02&orientation=squarish' },
    { name: '张同学', role: '生活类创作者', content: '最喜欢快猫的创作者社区氛围，大家互相帮助互相学习。平台还会定期组织线上线下活动，认识了很多志同道合的朋友。', avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20student%20with%20a%20bright%20smile%2C%20casual%20style%2C%20cream%20background%2C%20warm%20portrait%20lighting&width=100&height=100&seq=testimonial-03&orientation=squarish' },
  ],
  contact: {
    email: 'support@kuaimao.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园A座',
    wechat: 'kuaimaoshipin',
    workingHours: '周一至周五 9:00-18:00',
  },
};

export const faqList = [
  { q: '快猫短视频如何下载？', a: '您可以在各大应用商店（App Store、华为应用市场、小米应用商店等）搜索"快猫短视频"下载。也可以访问官网扫码下载最新版本。' },
  { q: '如何成为快猫短视频创作者？', a: '下载快猫短视频APP后，点击底部"+"发布按钮，上传您的第一条视频即可成为创作者。平台提供完善的创作工具和教程，帮助您快速上手。' },
  { q: '创作者如何获得收益？', a: '快猫短视频为创作者提供多种变现方式：视频播放收益、直播打赏、品牌合作、电商带货等。收益按月结算，满100元即可提现。' },
  { q: '平台如何保证内容质量？', a: '我们采用AI+人工双重审核机制，所有上传视频均经过智能审核和人工抽检，确保内容合规、优质。同时设有用户举报渠道，共建清朗社区。' },
  { q: '快猫短视频适合哪些人群？', a: '快猫短视频面向所有年龄段的用户，根据您的观看偏好智能推荐内容。无论您喜欢搞笑、美食、旅行还是知识科普，都能在这里找到感兴趣的内容。' },
  { q: '个人隐私如何保护？', a: '我们严格遵守数据保护法规，采用加密技术保护用户数据安全。用户可以随时在设置中管理隐私权限，控制个人信息的可见范围。' },
];